import { Outlet, Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.jsx';
import './Layout.css';

export default function Layout() {
  const { isAuthenticated, customer, logout } = useAuth();

  return (
    <div className="app-layout">
      <header className="app-header">
        <div className="container header-inner">
          <Link to="/" className="header-logo" aria-label="WAW Maroc — accueil">
            <img src="/waw-logo.png" alt="WAW Maroc" />
          </Link>
          <nav className="header-nav">
            {isAuthenticated ? (
              <>
                <Link to="/compte/reservations" className="header-link">Mes réservations</Link>
                <Link to="/compte/fidelite" className="header-link">Fidélité</Link>
                <Link to="/compte/profil" className="header-link header-link-user">
                  {customer?.firstName || 'Mon compte'}
                </Link>
                <button onClick={logout} className="header-link header-logout">Déconnexion</button>
              </>
            ) : (
              <>
                <Link to="/compte/connexion" className="header-link">Connexion</Link>
                <Link to="/compte/inscription" className="btn btn-primary btn-sm">Inscription</Link>
              </>
            )}
          </nav>
        </div>
      </header>
      <main className="app-main">
        <Outlet />
      </main>
      <footer className="app-footer">
        <div className="container footer-inner">
          <p>&copy; {new Date().getFullYear()} WAW Maroc — Tous droits réservés</p>
        </div>
      </footer>
    </div>
  );
}
